/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type CommentReferenceType = typeof CommentReferenceType[keyof typeof CommentReferenceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CommentReferenceType = {
  Ticket: 'Ticket',
  SurveyDialogue: 'SurveyDialogue',
} as const;
